import { CallToActionButton } from 'components/Button';
import { CmsApiStickyHeaderLinksGradBlockData } from 'modules/cms/api/types/CmsApiStickyHeaderLinksGrad';
import { useCurrentUserHasGradProgram, useIsLoggedIn } from 'modules/cms/hooks';

import { CmsStickyHeaderLinks } from './CmsStickyHeaderLinks';

type Props = {
  data: CmsApiStickyHeaderLinksGradBlockData;
};

export function CmsStickyHeaderLinksGradBlock({ data: { links } }: Props) {
  const loggedIn = useIsLoggedIn();
  const hasGradProgram = useCurrentUserHasGradProgram();

  return (
    <CmsStickyHeaderLinks
      links={links}
      button={
        <CallToActionButton
          loggedIn={loggedIn}
          hasGradProgram={hasGradProgram}
        />
      }
    />
  );
}
